<template>
  <div class="card5">
    <div class="cardInfo">
      <div class="title two_line" ref="title" @click.stop="goDetail">
        <span style="color: #008BFF;" v-if="item.zhuanti">专题 | </span>
        <span>{{ item.title }}</span>
      </div>
      <div class="otherInfo flex_center">
        <div class="sourceInfo flex_row flex_center">
          <div class="logo_box" v-if="userInfo.logo !== ''">
            <img class="sourceImg" :src="userInfo.logo" alt="">
            <img class="v_icon" :src="item.xinhua.vimgUrl" alt="" v-if="item.xinhua && item.xinhua.vflag">
          </div>
          <div class="sourceName">{{ userInfo.name }}</div>
          <div class="sourceName" v-if="item.commentNum">{{ item.commentNum }}评</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'card5',
  props: [ 'item' ],
  data () {
    return {
      lineNums: 2,
    }
  },
  computed: {
    // 用户信息
    userInfo () {
      let item = this.item
      let userInfo = {
        logo: '',
        name: item.sourceName || ''
      }
      if ( item.cuser ) {
        userInfo.logo = item.cuser.logo
        userInfo.name = item.cuser.name
        userInfo.uuid = item.cuser.cuserThirdId
      }
      if ( item.xinhua ) {
        userInfo.logo = item.xinhua.xinhuaCover
        userInfo.name = item.xinhua.xinHuaName
        userInfo.uuid = item.xinhua.xinHuaUuid
      }
      return userInfo
    }
  },
  mounted () {
    this.$nextTick( () => {
      this.init()
    } )
  },
  methods: {
    // 初始化
    init () {
      this.getTitleLine()
    },
    // 获取标题行数
    getTitleLine () {
      let dom = this.$refs[ 'title' ]
      if ( dom ) {
        let height = dom.offsetHeight
        let lineHeight = this.getAttr( dom, 'lineHeight' )
        if ( lineHeight ) {
          lineHeight = lineHeight.replace( /px/g, '' )
        }
        let line = Number( height ) / Number( lineHeight )
        if ( line > 0 ) {
          this.lineNums = line.toFixed( 0 )
        }
      }
    },
    // 获取属性
    getAttr ( obj, attr ) {
      let style
      if ( obj.currentStyle ) {
        style = obj.currentStyle[ attr ]
      } else {
        style = window.getComputedStyle( obj, false )[ attr ]
      }
      return style
    },
    // 打开详情
    goDetail () {
      this.$emit( 'pauseMedia' )
      window.goDetail( this.item )
    }
  }
}
</script>

<style scoped>
.card5 {
  width: 100%;
  height: 89px;
  background-image: url("../../../assets/images1/recommend/showType1_bg.png");
  background-size: cover;
  padding: 12px 16px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 12px;
  border-radius: 12px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 6%);
}

.lineNums1 {
  height: 69px;
  background-image: url("../../../assets/images1/recommend/showType5_bg_line2.png");
}

.cardInfo {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.title {
  font-size: 16px;
  line-height: 20px;
  color: #fff;
}

.otherInfo {
  display: flex;
  justify-content: space-between;
}

.sourceInfo {
  font-size: 12px;
  line-height: 17px;
  color: rgba(255, 255, 255, .65);
}

.sourceImg {
  width: 18px;
  height: 18px;
  display: block;
  margin-right: 10px;
  border-radius: 50%;
  object-fit: cover;
}

.logo_box {
  width: 20px;
  height: 19px;
  margin-right: 10px;
  position: relative;
}

.v_icon {
  width: 8px;
  height: 8px;
  object-fit: cover;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.sourceName {
  margin-right: 8px;
}
</style>